module.exports = __webpack_public_path__ + "statics/img/blue.658a5810.png";